import { JSX } from 'react';
import { MenuItem, TextField } from '@mui/material';
import { Report, REPORT_LANGUAGE_PROPERTY_LABEL, ReportProperty } from '../../common/types/reports';
import { useUpdateReport } from '../../common/components/mutations';

interface ReportLanguageSelectorProps {
  report: Report;
}

export const getReportLanguage = (report: Report): string | undefined =>
  report.properties.find(({ propertyLabel }) => propertyLabel === REPORT_LANGUAGE_PROPERTY_LABEL)
    ?.propertyValue || 'en';

/**
 * Component to change the language of the report
 */
const ReportLanguageSelector = ({ report }: ReportLanguageSelectorProps): JSX.Element => {
  const { mutate, isPending } = useUpdateReport();

  const handleChangeLanguage = (language: string): void => {
    const updatedProperties = [...report.properties];
    const propertyToUpdateIndex = updatedProperties.findIndex(
      ({ propertyLabel }) => propertyLabel === REPORT_LANGUAGE_PROPERTY_LABEL,
    );
    if (propertyToUpdateIndex >= 0) {
      updatedProperties[propertyToUpdateIndex].propertyValue = language;
    } else {
      updatedProperties.push({
        propertyLabel: REPORT_LANGUAGE_PROPERTY_LABEL,
        propertyValue: language,
        reportID: report.id,
      } as ReportProperty);
    }

    mutate({
      ...report,
      properties: updatedProperties,
    });
  };

  return (
    <TextField
      select
      disabled={isPending}
      className="w-32"
      label="Report language"
      defaultValue={getReportLanguage(report)}
      onChange={({ target }): void => handleChangeLanguage(target.value)}
    >
      <MenuItem value="en">English</MenuItem>
      <MenuItem value="af-ZA">Afrikaans</MenuItem>
    </TextField>
  );
};

export default ReportLanguageSelector;
